import React, { useState } from "react";
import "date-fns";
import { Button } from "react-materialize";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Alert from "@material-ui/lab/Alert";
import ConfigurationManager from "../../configuration/ConfigurationManager";
import Loading from "../loading/Loading";

export default function DialogBox({
  alert,
  totalCount,
  searchTerm,
  _handleClose,
  _handleSnackBarMessageDisplay,
  currentUserEmail,
  selectedAssets,
  handleClearClick,
}) {
  let tempDate = new Date();
  let month =
    tempDate.getMonth() + 1 < 10
      ? `0${tempDate.getMonth() + 1}`
      : `${tempDate.getMonth() + 1}`;
  let day =
    tempDate.getDate() < 10 ? `0${tempDate.getDate()}` : tempDate.getDate();
  let actualDate = month + `/` + day + `/${tempDate.getFullYear()}`;
  const [mailMesaage, setMailMessage] = useState(false);
  const [dateSelect, setDateSelect] = useState(false);
  const [startDate, setStartDate] = useState(actualDate);
  const [endDate, setEndDate] = useState(actualDate);
  const [confirmMessage, setConfirmMessage] = useState(true);
  const [alertMessage, setAlertMessage] = useState(null);
  const [sendingRequest, setSendingRequest] = useState(false);
  ConfigurationManager.environment = process.env;
  const handleContinue = () => {
    setConfirmMessage(false);
    setDateSelect(true);
  };

  const handleClose = () => {
    // setDialogOpen(false);
    _handleClose();
    setTimeout(() => {
      setConfirmMessage(true);
      setMailMessage(false);
      setDateSelect(false);
      setAlertMessage(null);
    }, 1000);

    // setDialogOpen(false);
  };
  const returnDateFormat = (date) => {
    // let time = new Date().toISOString().split("T")[1];
    let [month, day, year] = date.split("/");
    return `${year}-${month}-${day}`;
  };
  const handleDateContinue = async (event) => {
    let [month, date, year] = new Date().toLocaleDateString().split("/");
    let tempStartDate = new Date(startDate);
    let tempEndDate = new Date(endDate);
    let presentDate = new Date(`${year}-${month}-${date + 1}`);

    if (tempStartDate > presentDate || tempEndDate > presentDate) {
      _handleSnackBarMessageDisplay(`Dates cannot be greater present date`);
      return;
    } else if (tempStartDate > tempEndDate) {
      _handleSnackBarMessageDisplay(
        `End Date should be greater than Start Date`
      );
      return;
    } else {
      setSendingRequest(true);
      let filters = {};
      for (let key in searchTerm) {
        if (key === "queryParams") {
          continue;
        }
        let value = searchTerm[key];
        filters[key] = Array.isArray(value)
          ? value.map((val) => val.value)
          : value;
      }
      let REQUEST_URL = ConfigurationManager.getProperty("REPORT_API");
      let data = {
        email: currentUserEmail,
        filters,
        startDate: returnDateFormat(startDate),
        endDate: returnDateFormat(endDate),
        selectedAssets: selectedAssets !== null ? selectedAssets : null,
      };
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      let raw = JSON.stringify(data);
      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      await fetch(REQUEST_URL, requestOptions).then((response) => {
        if (response.status === 201) {
          setAlertMessage(
            "Thank you for your request! Soon, you will receive a download link for your report on your STAR LABS registered e-mail."
          );
          setDateSelect(false);
          setMailMessage(true);
        } else if (response.status === 200) {
          setAlertMessage(
            "Thank you for your request! We have sent download link for your report on your STAR LABS registered e-mail."
          );
          setDateSelect(false);
          setMailMessage(true);
        } else if (response.status === 202) {
          setAlertMessage(
            "Thank you, your request is in process! Soon, you will receive a download link for your report on your STAR LABS registered e-mail."
          );
          setDateSelect(false);
          setMailMessage(true);
        } else {
          setAlertMessage("Something went wrong. Please try after sometime!");
          setDateSelect(false);
          setMailMessage(true);
        }
        setSendingRequest(false);
      });
    }

    if (handleClearClick) {
      handleClearClick();
    }
  };

  return (
    <>
      <Dialog
        open={alert}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        {sendingRequest && <Loading message="Processing..." />}
        {confirmMessage &&
          dateSelect === false && (
            <div>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ textAlign: "justify" }}>
                  Please confirm that you wish to run an audit report on{" "}
                  {totalCount} asset(s) with the following filter(s):
                  {searchTerm !== null
                    ? Object.keys(searchTerm).map((key) => {
                        if (key !== "ecm_fulltext" && key !== "queryParams") {
                          if (
                            key.includes("styleGuideName") &&
                            searchTerm[key] !== null
                          ) {
                            let styleGuides = searchTerm[key];
                            return (
                              <>
                                <ul>
                                  <li key="StyleGuide">
                                    <b>Style Guide:</b>
                                    <ol>
                                      {styleGuides.map((styleguide) => {
                                        return (
                                          <li key={styleguide.label}>
                                            {styleguide.label}
                                          </li>
                                        );
                                      })}
                                    </ol>
                                  </li>
                                </ul>
                              </>
                            );
                          } else if (
                            key.includes("property") &&
                            searchTerm[key] !== null
                          ) {
                            let properties = searchTerm[key];
                            return (
                              <>
                                <ul>
                                  <li key="Property">
                                    <b>Property:</b>
                                    <ol>
                                      {properties.map((property) => {
                                        return (
                                          <li key={property.label}>
                                            {property.label}
                                          </li>
                                        );
                                      })}
                                    </ol>
                                  </li>
                                </ul>
                              </>
                            );
                          } else if (
                            key.includes("character") &&
                            searchTerm[key] !== null
                          ) {
                            let characters = searchTerm[key];
                            return (
                              <>
                                <ul>
                                  <li key="Character">
                                    <b>Character:</b>
                                    <ol>
                                      {characters.map((character) => {
                                        return (
                                          <li key={character.label}>
                                            {character.label}
                                          </li>
                                        );
                                      })}
                                    </ol>
                                  </li>
                                </ul>
                              </>
                            );
                          } else if (
                            key.includes("franchise") &&
                            searchTerm[key] !== null
                          ) {
                            let franchises = searchTerm[key];
                            return (
                              <>
                                <ul>
                                  <li key="Franchises">
                                    <b>Franchise:</b>
                                    <ol>
                                      {franchises.map((franchise) => {
                                        return (
                                          <li key={franchise.label}>
                                            {franchise.label}
                                          </li>
                                        );
                                      })}
                                    </ol>
                                  </li>
                                </ul>
                              </>
                            );
                          }
                        }
                        return <></>;
                      })
                    : null}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} className="button">
                  Cancel
                </Button>
                <Button
                  className="button"
                  onClick={handleContinue}
                  color="secondary"
                  autoFocus>
                  Continue
                </Button>
              </DialogActions>
            </div>
          )}
        {dateSelect && (
          <>
            <form noValidate onSubmit={() => {}}>
              <div className="date-container">
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ textAlign: "justify" }}>
                  {" "}
                  Select your date range
                </DialogContentText>
                <div className="date-selector">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      margin="normal"
                      id="start-date-picker-dialog"
                      label="Start Date"
                      format="MM/dd/yyyy"
                      value={startDate}
                      KeyboardButtonProps={{ "aria-label": "change date" }}
                      InputProps={
                        {
                          disableUnderline: true,
                          style: { borderColor: "blue" },
                        } // } //   { shrink: true } // className={classes.textField} // InputLabelProps={
                      }
                      onChange={(event, date) => {
                        setStartDate(date);
                        //   this.setState({ startDate: event });
                      }}
                    />
                    <KeyboardDatePicker
                      margin="normal"
                      id="end-date-picker-dialog"
                      label="End Date"
                      format="MM/dd/yyyy"
                      value={endDate}
                      KeyboardButtonProps={{ "aria-label": "change date" }}
                      InputLabelProps={
                        { shrink: true } // className={classes.textField}
                      }
                      InputProps={{
                        disableUnderline: true,
                        style: { borderColor: "blue" },
                      }}
                      onChange={(event, date) => {
                        setEndDate(date);
                        // this.setState({ endDate: event });
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </form>
            <DialogActions>
              <Button onClick={handleClose} className="button">
                Cancel
              </Button>
              <Button onClick={handleDateContinue} className="button" autoFocus>
                Continue
              </Button>
            </DialogActions>
          </>
        )}
        {mailMesaage && (
          <Alert
            severity="success"
            onClose={handleClose}
            style={{ textAlign: "center" }}>
            {alertMessage}
          </Alert>
        )}
      </Dialog>
    </>
  );
}
